import { memo } from 'react'
import { useToast } from './use-toast'
import { Toast } from './components/toast'
import { ToastViewport } from './toast-viewport'
import { useMeetingToasts } from './hooks/use-meeting-toasts'
import { useOnboardingCompletion } from '@renderer/hooks/use-onboarding-completion'
import { useAudioSummaryToasts } from './hooks/use-audio-summary-toasts'
import { useErrorToasts } from './hooks/use-error-toasts'
import { useInactivityToasts } from './hooks/use-inactivity-toasts'
import { useCalendarToasts } from './hooks/use-calendar-toasts'
import { useActionToasts } from './hooks/use-action-toasts'
import { useReminderToasts } from './hooks/use-reminder-toasts'
import { useChatCompletionToasts } from './hooks/use-chat-completion-toasts'
import { useClientToolToasts } from './hooks/use-client-tool-toasts'
import { useGatewayToasts } from './hooks/use-gateway-toasts'
import { useModelMigrationToast } from './hooks/use-model-migration-toast'
import { useMicGateToasts } from './hooks/use-mic-gate-toasts'
import { usePlanLiveToast } from './hooks/use-plan-live-toast'
import './toast-animations.css'

const Toaster = memo(() => {
  const toast = useToast()

  useMeetingToasts(toast)
  useOnboardingCompletion()
  useAudioSummaryToasts(toast)
  useErrorToasts(toast)
  useInactivityToasts(toast)
  useCalendarToasts(toast)
  useActionToasts(toast)
  useReminderToasts(toast)
  useChatCompletionToasts(toast)
  useClientToolToasts(toast)
  useGatewayToasts(toast)
  useModelMigrationToast(toast)
  useMicGateToasts(toast)
  usePlanLiveToast(toast)

  return <ToastViewport />
})

Toaster.displayName = 'Toaster'

export default Toaster
export { Toast, useToast }
export type { ToastOptions } from './types'
